import { Component, inject, model, ModelSignal, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose,   MatDialogContent,   MatDialogRef, } from '@angular/material/dialog';
import { customDialogResponse, DialogDataInterface } from './dialog-data.interface';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'confirm-dialog-notes',
    templateUrl: 'confirm-dialog-notes.html',
    imports: [MatButtonModule, MatDialogActions, MatDialogContent, MatFormFieldModule, FormsModule, MatIconModule]
})

export class ConfirmDialogWithNotes {

    readonly dialogRef = inject(MatDialogRef<ConfirmDialogWithNotes>);
    readonly configData = inject<DialogDataInterface>(MAT_DIALOG_DATA);
    comentarios: string = '';

    close(){
        const dialogResponse: customDialogResponse = {
            confirmed: false,
            comentarios: this.comentarios
        }
       this.dialogRef.close(dialogResponse)
    }

    confirmed(){
        const dialogResponse: customDialogResponse = {
            confirmed: true,
            comentarios: this.comentarios
        }
       this.dialogRef.close(dialogResponse)
    }
}